<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size lg_size">
            <a href="javascript:" class="ui_close" type="button" rel="modal:close" @click="$emit('close')"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis maintit">
                    <select class="slt_white" v-model="guideType">
                        <option value="" disabled>Select a guide</option>
                        <option value="dev">Developer Guide</option>
                        <option value="db">Database Guide</option>
                    </select>
                </dt>
                <dd>
                    <div class="preview_wrap scroll">
                        <div class="view_desc">
                            <DevNoteMarkdown v-show="isDev" />
                            <DBNoteMarkdown v-show="isDb" />
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_wrap topLine">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.CLOSE')" @click="$emit('close')">{{ $t('BUTTON.GLOBAL.CLOSE') }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import { SDLUtil }      from '@/utils';
import DevNoteMarkdown  from '../../../../../developer_guide.md';
import DBNoteMarkdown   from '../../../../../database_guide.md';
import 'highlight.js/styles/github-gist.css';

export default {
    name: 'DevGuidePopup',
    props: {
        title: {},
    },
    data() {
        return {
            guideType: 'dev',

            isDev: true,
            isDb: false
        }
    },
    watch: {
        guideType(v) {
            if(v === 'dev') {
                this.isDev = true;
                this.isDb = false;
            } else {
                this.isDev = false;
                this.isDb = true;
            }

            $('.view_desc').scrollTop(0);
        }
    },
    components: {
        DevNoteMarkdown,
        DBNoteMarkdown
    }
}; 
</script>
<style scoped>
.guide { height: 800px; overflow-y: auto; }
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/main/DevGuidePopup.vue